import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject, model } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable } from 'rxjs';

import { BaseComponent, GridService, ignoreModalError, ModalService, TabGridComponent } from 'tms-lib';
import { AddressAddressee, ProductCustomerDetails } from '../../../models';
import { AddressAddresseeService } from '../../../services';
import { AddressCreateAddresseesModalComponent } from '../address-create-addressees-modal/address-create-addressees-modal.component';

@Component({
  selector: 'app-address-addressees',
  templateUrl: './address-addressees.component.html',
  styleUrl: './address-addressees.component.scss',
  imports: [TabGridComponent, AsyncPipe],
})
export class AddressAddresseesComponent extends BaseComponent implements OnInit {
  private readonly addressAddresseeService = inject(AddressAddresseeService);
  private readonly gridService = inject(GridService);
  private readonly modalService = inject(ModalService);
  private readonly route = inject(ActivatedRoute);

  protected model$: Observable<AddressAddressee[]>;

  public readonly addressId = model<string>();

  protected fields: FormlyFieldConfig[];

  protected columnDefs: ColDef[] = [
    this.gridService.text('addressee', $localize`Addressee`),
    this.gridService.text('telephone', $localize`Telephone`),
    this.gridService.text('email', $localize`Email`),
    this.gridService.text('addressSingleLine', $localize`Address`),
  ];

  ngOnInit() {
    if (!this.addressId()) {
      this.addressId.set(this.route.snapshot.paramMap.get('id'));
    }
    this.getModel();
  }

  getModel() {
    this.model$ = this.addressAddresseeService.getForAddress(this.addressId());
  }

  create() {
    this.openAddressees(undefined, this.addressId());
  }

  edit(model: ProductCustomerDetails) {
    this.openAddressees(model.id);
  }

  delete(model: AddressAddressee) {
    this.addressAddresseeService
      .delete(model.id)
      .pipe(this.untilDestroyed())
      .subscribe(() => this.getModel());
  }

  private openAddressees(id: string, addressId?: string) {
    const { modal, component } = this.modalService.openMedium<AddressCreateAddresseesModalComponent>(
      AddressCreateAddresseesModalComponent,
    );
    component.id.set(id);
    component.addressId.set(addressId);
    modal.result.then(() => this.getModel(), ignoreModalError);
  }
}
